import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_AI_DRAFT_PROMPT = defineFcm('starfish_petition_ai_draft_prompt')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				variants: {
					type: 'record',
					keys: ['control', 'variant1', 'variant2', 'variant3', 'variant4'] as const,
					optionalValues: true,
					shape: {
						type: 'object',
						shape: {
							promptId: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-middle-end'],
		context: 'Start a Petition (SAP) AI draft',
		description: `Maps experiment-service variations to LangSmith Hub prompt id for SAP AI draft A/B tests.
    Used by the starfish_petition_ai_draft_prompt_experiment experiment.`,
		template: {
			experimentName: 'sap_ai_draft_test_1',
			variants: {
				control: { promptId: '' },
				variant1: { promptId: '' },
				variant2: { promptId: '' },
				variant3: { promptId: '' },
				variant4: { promptId: '' },
			},
		},
	});
